import React from 'react';
import SiteHeader from '../components/SiteHeader';

const SmartMail = () => {
  return (
    <div className="dbos-homepage">
      <SiteHeader active="solutions" />
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title shimmering gold-gradient">SmartMail</h1>
            <p className="hero-subtitle">Newsletters and customer replies, sorted. Dedicated infrastructure, 100% under your own brand.</p>
            <div className="hero-ctas">
              <a href="https://login.dbos.world/register" target="_blank" rel="noopener noreferrer" className="btn-primary shimmering-btn">
                Start Free Trial
                <span className="btn-arrow">→</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SmartMail;
